import styled, { css } from 'styled-components';
import { borderRadius, colorUsage, getSpacing } from 'stylesheet';
import { Picture } from 'theme/icons';
import { THUMBNAIL_SIZE } from '../constants';
var Container = styled.div.withConfig({
  displayName: "Thumbnailsstyle__Container",
  componentId: "sc-1so4ffc-0"
})(["display:flex;min-width:0;margin-right:", ";padding-bottom:", ";overflow:scroll;& >:not(:first-child){margin-left:", ";}&::-webkit-scrollbar{height:4px;}&::-webkit-scrollbar-thumb{background-color:", ";border-radius:4px;}"], getSpacing(1), getSpacing(0.5), getSpacing(1), colorUsage.scrollbar);
var previewStyle = css(["position:relative;width:", ";min-width:", ";height:", ";overflow:hidden;border-radius:", ";cursor:pointer;&:hover{border:1px solid ", ";}&:hover::after{position:absolute;top:0;left:0;width:100%;height:100%;background-color:", ";opacity:0.5;content:'';}"], THUMBNAIL_SIZE, THUMBNAIL_SIZE, THUMBNAIL_SIZE, borderRadius.medium, colorUsage.carousel.preview.hover, colorUsage.carousel.preview.hover);
var ThumbnailContainer = styled.div.withConfig({
  displayName: "Thumbnailsstyle__ThumbnailContainer",
  componentId: "sc-1so4ffc-1"
})(["", ""], previewStyle);
var Thumbnail = styled.img.withConfig({
  displayName: "Thumbnailsstyle__Thumbnail",
  componentId: "sc-1so4ffc-2"
})(["width:100%;height:100%;object-fit:cover;"]);
var Placeholder = styled.div.withConfig({
  displayName: "Thumbnailsstyle__Placeholder",
  componentId: "sc-1so4ffc-3"
})(["display:flex;align-items:center;justify-content:center;background-color:", ";", ""], colorUsage.carousel.preview.missing.background, previewStyle);
var PictureIcon = styled(Picture).withConfig({
  displayName: "Thumbnailsstyle__PictureIcon",
  componentId: "sc-1so4ffc-4"
})(["& path{fill:", ";}"], colorUsage.carousel.preview.missing.icon);
export { Container, Thumbnail, ThumbnailContainer, Placeholder, PictureIcon };